import React from 'react';

const Landing = () => {
  return <div>landing</div>;
};

export default Landing;
